import {Component} from "@angular/core";
import {FORM_DIRECTIVES} from "@angular/common";

@Component({
  selector: 'common-ngform-template',
  template: `
  <usecase-container title="NgForm (Template)" src="common/ngform-template">
    <usecase-content>
      <form #f="ngForm" (ngSubmit)="value=f.value">
        <p>Age(req): <input type="number" ngControl="age" required></p>
        <div ngControlGroup="name">
          <p>FirstName(req): <input ngControl="first" required></p>
          <p>LastName(req): <input ngControl="last" required></p>
        </div>
        <button [attr.disabled]="!f.valid?true:null">Submit</button>
      </form>
      <div>
        <pre>{{ value | json }}</pre>
      </div>
    </usecase-content>
  </usecase-container>
  `,
  directives: [FORM_DIRECTIVES],
})
export class NgFormTemplateComponent {
  private value: any = {};
}



/** WEBPACK FOOTER **
 ** ./script/common/ngform-template/component.ts
 **/